<template>
  <span :class="active ? 'zapi-tag-on' : 'zapi-tag-off'">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'ZapiPizzaTag',
  props: {
    label: { type: String, required: true },
    active: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss" scoped>
.zapi-tag-on {
  background-color: #e6f7ec;
  color: #1e8a4c;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
}
.zapi-tag-off {
  background-color: #f3f4f6;
  color: #9ca3af;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 600;
  text-decoration: line-through;
}
</style>